import { useState, useContext } from 'react';
import {
    AccordionHeader,
    AccordionItem,
    Button,
    AccordionBody,
} from 'reactstrap';
import { renderIcon } from '~/shared/components/icons';
import AddExpenses from './AddExpenses';
import { FundRequestContext } from '~/context/fundrequests';

const Expenses = ({ isExpanded, handleSubmission }) => {
    const [{ fundRequest, editMode }, fundRequestDispatch] =
        useContext(FundRequestContext);

    const handleAddExpensesBtnClick = (e) => {
        if (isExpanded('2')) e.stopPropagation();
        fundRequestDispatch({
            type: 'reset_expense_item',
        });
        fundRequestDispatch({
            type: 'set_edit_mode',
            payload: true,
        });
    };

    return (
        <AccordionItem>
            <AccordionHeader
                targetId='2'
                className='less-round-accordion-header'
            >
                <div>
                    <div>Expenses</div>
                    {!editMode && (
                        <div>
                            <Button
                                color='link'
                                size='sm'
                                style={{
                                    marginLeft: 2,
                                    padding: 'auto',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                                onClick={handleAddExpensesBtnClick}
                            >
                                {renderIcon('add')}
                                Add Expense
                            </Button>
                        </div>
                    )}
                </div>
            </AccordionHeader>
            <AccordionBody accordionId='2'>
                <AddExpenses handleSubmission={handleSubmission} />
            </AccordionBody>
        </AccordionItem>
    );
};

export default Expenses;
